module.exports = __webpack_public_path__ + "img/lasubeb_logo_only-1.2edca276.png";